import React from 'react';
import {View} from 'react-native';
import {IStateProps} from './model';
import {dateFormats} from '../../../shared/constants/date';
import {datePipe} from '../../../shared/pipes';
import {Text} from '../../../shared/components/text';
import {CustomScrollView} from '../../../shared/components/scrollView';
import {useStyles} from '../../../shared/hooks/styles';
import {useNavigation} from '@react-navigation/native';
import {useNotificationPressHandler} from '../hooks/useNotificationPressHandler';
import {Button} from '../../../shared/components/button';
import {DeviceSize} from '../../../shared/theme/helpers';
import {Container} from '../../../shared/components/container';
import Screen from '../../../shared/components/screen';
import {Html} from '../../../shared/components/html';
import {
  MixedTextToHtmlOnly,
  requestIdfromNotificationTextTopic,
  requestIdfromNotificationText,
} from '../../../shared/utils/text';
import {Screens} from '../../../shared/routing';
import {showDetailsButton} from '../../../shared/utils/showDetailsButton';

export default ({notification}: IStateProps) => {
  const navigation = useNavigation();
  const handlePress = useNotificationPressHandler(notification, navigation);

  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      container: {
        marginTop: 28,
        marginBottom: 37,
      },
      buttonWrap: {
        justifyContent: 'center',
        alignItems: 'center',
        marginVertical: 20,
      },
      button: mediaOnly(DeviceSize.mobile, {width: '100%'}, {maxWidth: 328}),
      time: {
        ...theme.fonts.body,
        color: theme.color.labelText,
        textAlign: 'right',
        marginTop: 20,
      },
    };
  });

  if (!notification) return null;

  const idFromNotificationText: RegExpMatchArray | undefined = requestIdfromNotificationText(notification?.text);
  const idFromNotificationTextTopic: RegExpMatchArray | null = requestIdfromNotificationTextTopic(notification);

  const id = (() => {
    if (idFromNotificationText) return idFromNotificationText;
    if (idFromNotificationTextTopic) return idFromNotificationTextTopic;
    return undefined;
  })();

  const handlePressAlt = () => {
    if (id !== undefined) {
      navigation.navigate(Screens.SupportServiceTab);
      setTimeout(() => navigation.navigate(Screens.SupportServiceTopics));
      setTimeout(() => navigation.navigate(Screens.SupportServiceTopic, {id: `${id[0]}`}));
    }
  };

  const referenceType = notification.referenceType ? notification.referenceType : '';
  let isShowing: boolean;
  if (showDetailsButton(referenceType) && !id) {
    isShowing = true;
  } else {
    isShowing = false;
  }

  return (
    <Screen fullWidth>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <Container style={styles.container}>
          <Html content={MixedTextToHtmlOnly(notification.text)} testID='topic-request-text' />
          {isShowing && handlePress ? (
            <View style={styles.buttonWrap}>
              <Button
                id='notification-description'
                style={styles.button}
                type='secondary'
                text='Подробнее'
                onPress={handlePress}
              />
            </View>
          ) : null}
          {id ? (
            <View style={styles.buttonWrap}>
              <Button
                id='notifications-description'
                style={styles.button}
                type='secondary'
                text='Подробнее'
                onPress={handlePressAlt}
              />
            </View>
          ) : null}
          <Text testID='notification-date' style={styles.time}>
            {datePipe(notification.dateTime, dateFormats.fullDateWithTime)}
          </Text>
        </Container>
      </CustomScrollView>
    </Screen>
  );
};
